export default "__VITE_ASSET__BPKFPmAI__"